// extracted by mini-css-extract-plugin
module.exports = {"root":"Cursor_root__uNc5K","cursor":"Cursor_cursor__2j-UG","prev":"Cursor_prev__2wDJp","progressCursor":"Cursor_progressCursor__2Fb6I"};